import React, { useState } from 'react';
import useApi from '../hooks/useApi';

export default function ForgotPasswordPage({ onShowLogin }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const { request } = useApi();

  const handleSubmit = async () => {
    setMessage('');
    if (!email) {
      setMessage('Please enter your email.');
      return;
    }
    setLoading(true);
    try {
      const res = await request({
        method: 'post',
        url: 'api/v1/users/forgot-password/',
        data: { email },
      });
      setSuccess(true);
      setMessage(res.message);
    } catch (err) {
      setMessage(err?.response?.data?.detail || 'Something went wrong. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>

      {!success ? (
        <>
          <p className="text-sm text-gray-600 mb-4 text-center">
            Enter your email and we&apos;ll send you a reset link.
          </p>
          <input
            type="email"
            placeholder="Email"
            className="w-full border px-3 py-2 rounded mb-6"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setMessage('');
            }}
          />
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-violet-900 text-white py-2 rounded hover:bg-violet-950 disabled:opacity-50"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </>
      ) : (
        <p className="text-sm text-green-700 text-center">{message}</p>
      )}

      {message && !success && (
        <p className="mt-4 text-center text-sm text-red-700">{message}</p>
      )}

      <p className="text-sm text-center mt-4">
        <button onClick={onShowLogin} className="text-violet-900 hover:underline">
          Back to Log In
        </button>
      </p>
    </div>
  );
}
